/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AdUserStateTarget {
    LOGGED = 'logged',
    NOT_LOGGED = 'not_logged',
    ATLEAST_ONE_NEWSLETTER = 'atleast_one_newsletter',
    THIS_AND_THAT_NO_ALCOHOL = 'this_and_that_no_alcohol',
    THIS_AND_THAT_NO_MEAT = 'this_and_that_no_meat',
    THIS_AND_THAT_NO_GLUTEN = 'this_and_that_no_gluten',
}
